import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

export const GiraffePopout = () => {
  const { pathname } = useLocation();
  const [active, setActive] = useState(false);
  const aliveRef = useRef(false);

  useEffect(() => {
    aliveRef.current = true;
    return () => {
      aliveRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (pathname !== "/") return;
    if (sessionStorage.getItem("pp_giraffe_popout")) return;
    sessionStorage.setItem("pp_giraffe_popout", "1");
    setTimeout(() => {
      if (aliveRef.current) setActive(true);
    }, 900);
    setTimeout(() => {
      if (aliveRef.current) setActive(false);
    }, 900 + 4800);
  }, [pathname]);

  return (
    <AnimatePresence>
      {active && (
        <motion.div
          key="giraffe-popout"
          data-testid="giraffe-popout"
          className="fixed inset-0 z-[90] flex items-end justify-center overflow-hidden"
          style={{ perspective: "1200px" }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {/* dim backdrop, click to dismiss */}
          <motion.div
            className="absolute inset-0 bg-[#1C1917] cursor-pointer"
            style={{ pointerEvents: "auto" }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.42 }}
            exit={{ opacity: 0 }}
            onClick={() => setActive(false)}
            data-testid="giraffe-popout-backdrop"
          />

          {/* depth vignette behind the giraffe */}
          <motion.div
            className="absolute left-1/2 -translate-x-1/2 bottom-0 pointer-events-none"
            style={{
              width: "80vmin",
              height: "80vmin",
              background:
                "radial-gradient(closest-side, rgba(159,88,63,0.55), rgba(28,25,23,0.0) 70%)",
              filter: "blur(8px)",
            }}
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
          />

          {/* the pop-out group */}
          <div className="relative flex flex-col items-center" style={{ transformStyle: "preserve-3d" }}>
            {/* greeting bubble */}
            <motion.div
              className="absolute -top-4 z-20 whitespace-nowrap bg-white border border-[#E7E5E4] shadow-xl px-5 py-2.5 rounded-full font-body text-[#1C1917]"
              initial={{ opacity: 0, y: 12, scale: 0.85 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, scale: 0.85 }}
              transition={{ delay: 1.0, type: "spring", stiffness: 200, damping: 16 }}
            >
              Ciao! Benvenuto nel Cassetto delle Giraffe
            </motion.div>

            {/* giraffe emerging */}
            <motion.img
              src="/giraffe-popout.png"
              alt=""
              aria-hidden="true"
              data-testid="giraffe-popout-img"
              className="relative z-10 select-none"
              style={{
                height: "78vh",
                width: "auto",
                transformOrigin: "bottom center",
                WebkitMaskImage: "linear-gradient(to bottom, black 80%, transparent 100%)",
                maskImage: "linear-gradient(to bottom, black 80%, transparent 100%)",
                filter: "drop-shadow(0 24px 30px rgba(0,0,0,0.45))",
                pointerEvents: "none",
              }}
              initial={{ opacity: 0, scale: 0.28, rotateX: 55, y: 90 }}
              animate={{ opacity: 1, scale: 1, rotateX: 0, y: 0 }}
              exit={{ opacity: 0, scale: 0.3, rotateX: 50, y: 90 }}
              transition={{ delay: 0.3, type: "spring", stiffness: 80, damping: 13 }}
            />

            {/* glowing portal rim at the base */}
            <motion.div
              className="absolute bottom-0 left-1/2 -translate-x-1/2 z-[15] pointer-events-none"
              style={{
                width: "46vh",
                height: "9vh",
                borderRadius: "50%",
                background:
                  "radial-gradient(closest-side, rgba(233,185,73,0.9), rgba(159,88,63,0.55) 55%, rgba(28,25,23,0.0) 78%)",
                filter: "blur(3px)",
              }}
              initial={{ opacity: 0, scaleX: 0.4 }}
              animate={{ opacity: 1, scaleX: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
